import { useEffect } from 'react';
import { setPrimaryTracker } from 'usage-tracker-container';
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import UsageTrackerPublic from './utils/UsageTrackerPublic';
// @ts-expect-error Untyped module
import PublicAchievementContainer from './containers/Achievements/PublicAchievementContainer';
import { dataFetchingClient } from './utils/DataFetchingClient';
import { DataFetchingClientProvider } from 'academy-common-lib/utils/DataFetchingClient';
import { BrowserRouter, Route } from 'quartz-routing/react-router';
import { ThemeProvider } from 'academy-common-lib/utils/Styling';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicAppRouter = () => {
  useEffect(() => {
    setPrimaryTracker(UsageTrackerPublic.tracker);
  }, []);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(ThemeProvider, {
      children: /*#__PURE__*/_jsxs(DataFetchingClientProvider, {
        client: dataFetchingClient,
        children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(BrowserRouter, {
          basename: "/academy",
          children: /*#__PURE__*/_jsx(Route, {
            children: ({
              history
            }) => /*#__PURE__*/_jsx(RhumbProvider, {
              config: rhumbConfig // defining rhumbConfig as any is common across HubSpot due to lack of types
              ,
              history: historyAdapter(history),
              children: /*#__PURE__*/_jsx(Route, {
                component: PublicAchievementContainer,
                path: `/achievements/:publicId/:language/:template/:slug+`
              })
            })
          })
        })]
      })
    })
  });
};
export default PublicAppRouter;